module.exports = __webpack_public_path__ + "static/media/HDJN09.de481388.jpg";